import React from 'react';
import authenticationService from '../../../authenticationService';
import Swal from 'sweetalert2';
import { withRouter, Prompt } from 'react-router';
import ItemSearchInput from './ItemSearchInput';
import Loading from '../Common/Loading';
import CustomerPortalAction from '../../../actions/CustomerPortalAction';
import CustomerPortalStore from '../../../stores/CustomerPortalStore';
import ERROR_ICON from '../../../actions/error_icon.svg';

const $ = window.$;

const dateFormat = 'mm/dd/yyyy';
const BILLING_ADDRESS_SHIPTO = "BillingAddress";
class OrderEntry extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            onSubmit: false,
            shipViaCodes: [],
            selectedShipViaCode: "",
            selectedShipViaCodeName: "",
            shipToLocations: [],
            selectedShipToLocation: "",
            shipToName: "",
            address1: "",
            address2: "",
            country: "",
            city: "",
            stateOrProvince: "",
            zipOrPostalCode: "",
            phoneNumber: "",
            email: "",
            poNumber: "",
            requestDeliveryDate: "",
            comments: "",
            disabled: true,
            open: true,
            items: [],
            value: true,

            orderTypes: [],
            allowMiscCharge: false,
            allowPriceOverride: false,
            noteToCustomer: "",

            showItemDetails: false,
            hasShowItemDetails: false,

            shipVia: false,

            confirmToClose: false,
            isFetching: false,
            translation: undefined,
        };

        fetch('./lang/application-' + window.getLanguage() + '.json')
            .then(response => response.json())
            .then((json) => {
                this.setState({
                    translation: json
                })
            });

        this.handleInputChange = this.handleInputChange.bind(this);


        fetch("" + '/erp/OrderEntry/Settings', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then(response => response.json()).then(settings => {
            if (settings.error) {
                CustomerPortalAction.displayGeneralMessage(settings.error, undefined, undefined, undefined, { autoRedirect: false });
            } else {
                this.setState({
                    orderTypes: settings.orderTypes,
                    allowMiscCharge: settings.allowMiscCharge,
                    allowPriceOverride: settings.allowPriceOverride,
                    noteToCustomer: settings.noteToCustomer,
                    showItemDetails: settings.showItemDetails,
                    hasShowItemDetails: settings.showItemDetails,
                    shipVia: settings.shipVia
                });
            }
        }).catch((error) => {
            CustomerPortalAction.displayGeneralMessage();
            console.error(`fetch error: ${error}`);
            this.setState({ onSubmit: false });
        });
    }

    submit(orderType) {
        this.setState({ onSubmit: true });
        let order = new Object();
        order.description = "Web order - PO: " + this.state.poNumber;
        order.orderType = orderType.trim();
        order.poNumber = this.state.poNumber;
        if (this.state.selectedShipViaCode) {
            order.shipViaCode = this.state.selectedShipViaCode;
        }
        order.shipToCode = (this.state.selectedShipToLocation == BILLING_ADDRESS_SHIPTO) ? ("") : (this.state.selectedShipToLocation);
        order.shipToName = this.state.shipToName;
        order.shipToAddress1 = this.state.address1;
        order.shipToAddress2 = this.state.address2;
        order.shipToCity = this.state.city;
        order.shipToStateOrProv = this.state.stateOrProvince;
        order.shipToCountry = this.state.country;
        order.shipToPostalCode = this.state.zipOrPostalCode;
        order.shipToPhone = this.state.phoneNumber;
        order.shipToEmail = this.state.email;
        order.itemTotal = this.state.items.reduce(function (prev, current) {
            return prev + +current.extendedPrice
        }, 0);
        order.itemTotal = window.formatNum(order.itemTotal);
        order.miscCharge = "0";
        order.orderTotal = this.state.items.reduce(function (prev, current) {
            return prev + +current.extendedPrice
        }, 0);
        order.orderTotal = window.formatNum(order.orderTotal);
        order.shippingInstructionsComment = this.state.comments;
        order.requestDeliveryDate = this.state.requestDeliveryDate;
        order.orderDetails = [];
        this.state.items.map((item, i) => {
            let detail = new Object();
            detail.itemNumber = item.itemNo;
            detail.description = item.description
            detail.quantityOrdered = item.quantity;
            detail.unitOfMeasure = item.uom;
            detail.unitPrice = item.price;
            detail.comment = "";
            detail.extendedPrice = item.extendedPrice;
            detail.lineType = item.type;

            // include only valid ordered quantity line
            if (detail.quantityOrdered)
                order.orderDetails.push(detail);
        });

        if (order.orderDetails.length > 0) {
            fetch("" + '/erp/OrderEntry/OrderEntry', {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': authenticationService()
                },
                body: JSON.stringify(order),
            }).then((response) => {
                if (response.status !== 200)
                    throw new Error(response.status)
                return response.json();
            }).then((result) => {
                this.setState({ onSubmit: false });

                if (result.orderNumber) {
                    Swal.fire({
                        title: '<strong>' + this.state.translation.orderEntry.orderNumber + ': ' + result.orderNumber + '</strong>',
                        html: this.state.translation.orderEntry.orderSuccess,
                        focusConfirm: false,
                        showCancelButton: true,
                        reverseButtons: true,
                        cancelButtonText: this.state.translation.orderEntry.close,
                        confirmButtonColor: '#17a2b8',
                        confirmButtonText: this.state.translation.orderEntry.viewOrPrint
                    }).then((confirm) => {
                        this.setState({ items: [], confirmToClose: false }); // clear order detail lines when order/quote is posted.
                        if (confirm.value) {
                            this.props.history.push('/orders/docNo=' + result.orderNumber);
                        } else {
                            // refresh order screen
                            this.props.history.push('/order');
                        }
                    });
                } else if (result.error) {
                    CustomerPortalAction.displayGeneralMessage(result.error, undefined, undefined, undefined, { autoRedirect: false });
                } else {
                    // error occurs
                    console.log(result);
                }
            }).catch((error) => {
                CustomerPortalAction.displayGeneralMessage();
                console.error(`fetch error: ${error}`);
                this.setState({ onSubmit: false });
            });
        } else {
            if (!this.state.translation) { return; }
            CustomerPortalAction.displayGeneralMessage('', this.state.translation.orderEntry.pleaseSelect, 'warning', true, { autoRedirect: false });
            this.setState({ onSubmit: false });
        }
    }

    handleShipViaCodeChange(e) {
        let code = e.target.options[e.target.options.selectedIndex].value;
        let shipViaCode = this.state.shipViaCodes.find(element => element.code === code);
        this.setSelectedShipViaCode(shipViaCode);
    }

    handleShipToLocationChange(e) {
        let id = e.target.options[e.target.options.selectedIndex].value;
        let shipToLocation = this.state.shipToLocations.find(element => element.id === id);
        this.setSelectedShipToLocation(shipToLocation);
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }
    handleDeliverDateChange(e){
      if(e.keyCode == 8){ //reset delivery date value on backspace
        this.setState({requestDeliveryDate: ""});
      }
    }
    overWriteUnitPrice(e, index) {
        let value = e.target.value;
        const rgx = /^[0-9]*\.?[0-9]*$/;
        if (!value || !value.trim().match(rgx)) {
            value = 0;
        }
        this.state.items[index].overwritePrice = true;
        this.state.items[index].price = value;
        this.state.items[index].extendedPrice = parseFloat(this.state.items[index].price * this.state.items[index].quantity);
        this.forceUpdate();
    }

    handlePricingChange(e, index, delay) {
        let quantity = this.state.items[index].quantity;
        let uom = this.state.items[index].uom;
        let type = this.state.items[index].type;

        if (e.target.name === "quantity") {
            quantity = e.target.value;
            const rgx = /^[0-9]*\.?[0-9]*$/;
            if (!quantity.match(rgx)) {
                quantity = 0;
            }
            if (this.state.items[index].quantity == quantity && quantity == 1) { return; }
            this.state.items[index].quantity = quantity;
        } else if (e.target.name === "uom") {
            uom = e.target.value;
            this.state.items[index].uom = uom;
        }

        if (!delay && this.state.items[index].overwritePrice == null || this.state.items[index].overwritePrice === false) {
            fetch("" + '/erp/OrderEntry/ItemPricing?itemNo=' + encodeURIComponent(this.state.items[index].itemNo)
                + '&uom=' + encodeURIComponent(uom)
                + '&quantity=' + quantity
                + '&itemType=' + type, {
                headers: {
                    'Authorization': authenticationService()
                }
            }).then((response) => {
                if (response.status !== 200)
                    throw new Error(response.status)
                return response.json();
            }).then((itemPricing) => {
                if(itemPricing.error){
                  CustomerPortalAction.displayGeneralMessage(itemPricing.error);
                } else if (itemPricing.itemNo) {
                    this.state.items[index].price = itemPricing.unitPrice;
                    this.state.items[index].extendedPrice = parseFloat(itemPricing.unitPrice * quantity);

                    this.forceUpdate();
                } else {
                    Swal.fire(itemPricing);
                }
            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        } else {
            this.state.items[index].extendedPrice = parseFloat(this.state.items[index].price * quantity);
            this.forceUpdate();
        }
    }

    toggle() {
        this.setState({
            open: !this.state.open
        });
    }

    remove(e) {
        if (!this.state.translation) { return; }

        Swal.fire({
            title: this.state.translation.orderEntry.areYouSure,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.state.translation.orderEntry.yesDelete
        }).then((result) => {
            if (result.value) {
                var array = [...this.state.items];
                var index = array.indexOf(e)
                if (index !== -1) {
                    array.splice(index, 1);
                    this.setState({ items: array });
                    this.forceUpdate();
                }
            }
        });
    }

    clear() {
        if (!this.state.translation) { return; }
        Swal.fire({
            title: this.state.translation.orderEntry.areYouSureClearOrder,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.state.translation.orderEntry.yes,
            cancelButtonText: this.state.translation.orderEntry.cancel,
        }).then((result) => {
            if (result.value) {
                // clear items
                this.setState({ items: [], confirmToClose: false });
            }
        });
    }

    setSelectedShipViaCode(shipViaCode) {
        let code = "";
        let name = "";
        if (shipViaCode) {
            code = shipViaCode.code;
            name = shipViaCode.name;
        }
        this.setState({
            selectedShipViaCode: code,
            selectedShipViaCodeName: name
        });
    }

    setSelectedShipToLocation(shipToLocation) {
        console.log(shipToLocation)
        if (shipToLocation) {
            this.setState({
                selectedShipToLocation: shipToLocation.id,
                shipToName: shipToLocation.shipToName,
                address1: shipToLocation.address1,
                address2: shipToLocation.address2,
                country: shipToLocation.country,
                city: shipToLocation.city,
                stateOrProvince: shipToLocation.stateOrProvince,
                zipOrPostalCode: shipToLocation.zipOrPostalCode,
                phoneNumber: shipToLocation.phoneNumber,
                email: shipToLocation.email,
                disabled: true
            });
        } else { // clear
            this.setState({
                selectedShipToLocation: "",
                shipToName: "",
                address1: "",
                address2: "",
                country: "",
                city: "",
                stateOrProvince: "",
                zipOrPostalCode: "",
                phoneNumber: "",
                email: "",
                disabled: false
            });
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    // display only
    showItemDetail(itemNumber, description, additionalInfos, imageUrls, quantity, uom, uoms, price, extendedPrice, addBtnTxt) {
        $('.fa-calendar').hide();
        if (!addBtnTxt) { addBtnTxt = '<span data-translation="orderEntry.add"></span>' }

        let additionalInfosTxt = "";
        for (let i = 0; i < additionalInfos.length; i++) {
            additionalInfosTxt += "<div class='mb-1 pre-line'>" + additionalInfos[i] + "</div>";
        }

        let uomTxt = '';
        let uomSelectionVisible = '';
        if (uoms.length == 1) {
            uomTxt = uoms[0];
            uomSelectionVisible = 'd-none';
        }
        uomTxt += '<select id="uom" class="select-custom bold ' + uomSelectionVisible + '">';
        for (let i = 0; i < uoms.length; i++) {
            let isSelected = uom == uoms[i] ? ' selected="selected" ' : "";
            uomTxt += '<option' + isSelected + '>' + uoms[i] + '</option>';
        }
        uomTxt += '</select>';

        let priceTxt = ``;
        if (this.state.allowPriceOverride) {
            priceTxt = `<span id="price" class="d-none">${window.window.formatNum(price)}</span><input class="order-entry-price-pop-up" id="priceInput" value=${window.formatNum(price)} type="number" />`;
        } else {
            priceTxt = `<span id="price">${window.window.formatNum(price)}</span>`;
        }

        let imageSlide = '';
        let imageIndicators = '<ul class="carousel-indicators">';
        let images = '<div class="carousel-inner">';
        if (imageUrls && imageUrls.length > 0) {
            for (let i = 0; i < imageUrls.length; i++) {
                let active = (i === 0) ? 'active' : ''; // first image is default
                imageIndicators += `<li data-target="#itemImage" data-slide-to="${i}" class="${active}"></li>`;
                images += `<div class="carousel-item ${active}" style="max-width: 420px;">
                                  <img src="${imageUrls[i]}" class="img-fluid"/>
                           </div>`;
            }

            imageSlide = `<div class="col">
                            <div id="itemImage" class="carousel slide" data-ride="carousel">
                              ${imageIndicators}</ul>
                              ${images}</div>
                              <a class="carousel-control-prev" href="#itemImage" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                              </a>
                              <a class="carousel-control-next" href="#itemImage" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                              </a>
                            </div>
                          </div>`
        }

        // render modal
        let modal = `<div class="container-fluid" style='font-size: smaller;'>
                      <div class="row">
                        ${imageSlide}
                        <div class="col text-left pre-line">
                            <p class='green-text-color font-weight-bold text-uppercase'><span data-translation='orderEntry.itemNo'></span> ${itemNumber}</p>
                            <h4 class="font-weight-light mt-2 mb-2 pre-line">${description}</h4>
                            <p class='green-text-color font-weight-bold text-uppercase mt-4 mb-1'><span data-translation='orderEntry.additionalInfo'></span></p>
                            ${additionalInfosTxt}
                            <div class="mt-5">
                                <table style="width:100%">
                                      <tr>
                                        <th class='green-text-color text-uppercase'><span data-translation='orderEntry.quantity'></span></th>
                                        <th class='green-text-color text-uppercase'><span data-translation='orderEntry.uom'></span></th>
                                        <th class='green-text-color text-right text-uppercase'><span data-translation='orderEntry.price'></span></th>
                                        <th class='green-text-color text-right text-uppercase'><span data-translation='orderEntry.extendedPrice'></span></th>
                                      </tr>
                                      <tr>
                                        <td><input id="quantity" class="order-entry-quantity-pop-up" value='${quantity}'" /></td>
                                        <td>${uomTxt}</td>
                                        <td class="text-right">${priceTxt}</td>
                                        <td class="text-right">$<span id="extendedPrice">${window.window.formatNum(extendedPrice)}</span></td>
                                        <td rowspan="2">
                                            <button class="btn btn-custom float-right" id="addBtn">${addBtnTxt}</button>
                                        </td>
                                      </tr>
                                 </table>
                            </div>
                        </div>
                      </div>
                    </div>`
        return modal;
    }

    // without details
    fetchPricing(itemNumber, quantity, uom, targetPriceElement, targetPriceInputElement, targetExtendedPriceElement, targetActiveElements) {
        $(targetActiveElements).prop("disabled", true);
        fetch("" + '/erp/OrderEntry/ItemPricing?itemNo=' + encodeURIComponent(itemNumber)
            + '&uom=' + encodeURIComponent(uom)
            + '&quantity=' + quantity, {
            headers: {
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json();
        }).then((itemPricing) => {
            if (itemPricing.itemNo) {
                let price = itemPricing.unitPrice;
                let extendedPrice = parseFloat(itemPricing.unitPrice * quantity);
                $(targetPriceInputElement).val(price);
                $(targetPriceElement).text(price);
                $(targetExtendedPriceElement).text(extendedPrice);
                $(targetActiveElements).prop("disabled", false);
            } else {
                Swal.fire(itemPricing);
            }
        }).catch((error) => {
            console.error(`fetch error: ${error}`);
            $(targetActiveElements).prop("disabled", false);
        });
    }

    // with details
    fetchPricingWithDetails(selected, index) {
        let itemNumber = selected.itemNo;
        let isExisting = index >= 0;
        let addBtnTxt = "";

        let uri = "" + '/erp/OrderEntry/ItemPricingDetails?itemNo=' + encodeURIComponent(itemNumber);
        let quantity = 1;
        let uom = '';
        if (isExisting) {
            quantity = this.state.items[index].quantity;
            uom = this.state.items[index].uom;
            uri += '&uom=' + encodeURIComponent(uom) + '&quantity=' + quantity;
            addBtnTxt = '<span data-translation="orderEntry.update"></span>';
        }
        this.setState({ value: false, isFetching: true });
        fetch(uri, {
            headers: {
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json();
        }).then((details) => {
            if (details.itemNo) {
                let itemNumber = details.itemNo;
                let price = (isExisting) ? (this.state.items[index].price) : details.unitPrice;
                let UOMs = (isExisting) ? (this.state.items[index].UOMs) : details.uoMs;
                uom = (isExisting) ? (this.state.items[index].uom) : details.uom;
                let extendedPrice = parseFloat(price * quantity);
                let description = details.description;
                let additionalInfos = details.additionalInfos;
                let imageUrls = details.imageUrls;

                let popupWidth = document.querySelector('.div-oe-form').offsetWidth ?? '100%';
                if (!imageUrls || imageUrls.length == 0) {
                    popupWidth = '500pt';
                }

                Swal.fire({
                    html: this.showItemDetail(itemNumber, description, additionalInfos, imageUrls, quantity, uom, UOMs, price, extendedPrice, addBtnTxt),
                    width: popupWidth,
                    showConfirmButton: false,
                    showCloseButton: true,
                    allowOutsideClick: false,
                    onBeforeOpen: () => {
                        window.translate();
                        let overwritePrice = false;
                        document.querySelector('#quantity').addEventListener('change', () => {
                            if (!overwritePrice) {
                                this.fetchPricing(itemNumber, $("#quantity").val(), $("#uom option:selected").text(), "#price", "#priceInput", "#extendedPrice", "#addBtn");
                            } else { // if the price has been overwritten
                                let price = $('#priceInput').val();
                                let quantity = $('#quantity').val();
                                $('#extendedPrice').text(window.window.formatNum(parseFloat(price) * parseFloat(quantity)));
                            }
                        });

                        document.querySelector('#uom').addEventListener('change', () => {
                            if (!overwritePrice) {
                                this.fetchPricing(itemNumber, $("#quantity").val(), $("#uom option:selected").text(), "#price", "#priceInput", "#extendedPrice", "#addBtn");
                            }
                        });

                        if (this.state.allowPriceOverride) {
                            document.querySelector('#priceInput').addEventListener('change', () => {
                                let price = $('#priceInput').val();
                                let quantity = $('#quantity').val();
                                $('#price').text(price);
                                $('#quantity').val(quantity);
                                $('#extendedPrice').text(window.window.formatNum(parseFloat(price) * parseFloat(quantity)));
                                overwritePrice = true;
                            });
                        }

                        document.querySelector("#addBtn").addEventListener('click', () => {
                            Swal.clickConfirm();
                        });
                    },
                    onOpen: () => { $('#quantity').select(); },
                    preConfirm: function () {
                        return new Promise((resolve, reject) => {
                            let uoms = $("#uom>option").map(function () { return $(this).text(); }).get();

                            resolve({
                                itemNumber: itemNumber,
                                description: description,
                                extendedPrice: $('#extendedPrice').text(),
                                price: $('#price').text(),
                                uom: $('#uom').find(":selected").text(),
                                uoms: uoms,
                                quantity: $('#quantity').val(),
                            });
                        });
                    }
                }).then((data) => {
                    if (data && data.value && data.value.itemNumber) {
                        let item = new Object();
                        item.itemNo = data.value.itemNumber;
                        item.description = data.value.description;
                        item.price = data.value.price;
                        item.uom = data.value.uom;
                        item.quantity = data.value.quantity;
                        item.UOMs = data.value.uoms;
                        item.extendedPrice = data.value.extendedPrice;
                        item.type = selected.type;

                        if (isExisting) {
                            this.state.items[index].quantity = parseFloat(item.quantity);
                            this.state.items[index].uom = item.uom;
                            this.state.items[index].price = parseFloat(item.price);
                            this.state.items[index].extendedPrice = parseFloat(item.price * item.quantity);
                            this.forceUpdate();
                        } else {
                            this.setState({
                                items: this.state.items.concat([item]),
                                confirmToClose: true
                            });
                        }
                    }

                    $('.fa-calendar').show();
                    this.setState({ value: true, isFetching: false });
                });
            }
        }).catch((error) => {
            console.error(`fetch error: ${error}`);
            this.setState({ value: true, isFetching: false });
        });
    }

    // on selected item
    onInputChange(value) {
        this.setState({
            value: false
        });

        if (value && value[0]) {
            let selected = value[0];
            selected.itemNo = selected.id;

            // if enhance, show this instead.
            if (this.state.showItemDetails && selected.type === 'Item') { // add new
                this.fetchPricingWithDetails(selected, -1);
            } else { // no details
                let item = new Object();
                item.itemNo = selected.itemNo;
                item.description = selected.description;
                item.type = selected.type;

                fetch("" + '/erp/OrderEntry/ItemPricing?itemNo=' + encodeURIComponent(item.itemNo) + '&itemType=' + item.type, {
                    headers: {
                        'Authorization': authenticationService()
                    }
                }).then((response) => {
                    if (response.status !== 200)
                        throw new Error(response.status)
                    return response.json();
                }).then((itemPricing) => {
                    if (itemPricing.itemNo) {
                        item.price = itemPricing.unitPrice;
                        item.uom = itemPricing.uom;
                        item.quantity = 1;
                        item.UOMs = itemPricing.uoMs;
                        item.extendedPrice = itemPricing.unitPrice;

                        this.setState({
                            items: this.state.items.concat([item]),
                            confirmToClose: true
                        });

                        this.setState({
                            value: true
                        });
                        if (this.refs['quantity'] && item.type === 'Item')
                            this.refs['quantity'].focus();
                        else if (this.refs['unitPrice'])
                            this.refs['unitPrice'].focus();
                    } else {
                        Swal.fire(itemPricing);
                    }
                }).catch((error) => {
                    console.error(`fetch error: ${error}`);
                });
            }
        }
    }

    componentDidUpdate(prevProps,prevState) {
      if(prevState.isLoading && !this.state.isLoading){
          //move datepicker to componentDidUpdate to make sure element exist when initializing
          $('.datepicker').datepicker({
              format: dateFormat,
              autoclose: true,
              startDate: new Date().toLocaleDateString('en-US').split`T`[0],
          });
          $('.datepicker').datepicker().on("changeDate",function(e){
            this.handleChange(e);
          }.bind(this));
      }
    }

    componentWillUnmount() {
        $('[data-toggle="tooltip"]').tooltip();
        if (this.state.confirmToClose) {
            window.onbeforeunload = () => true
        } else {
            window.onbeforeunload = null
        }

        window.onbeforeunload = null
    }

    componentDidMount() {
        if (!this.state.translation) {
            fetch('./lang/application-' + window.getLanguage() + '.json')
                .then(response => response.json())
                .then((json) => {
                    this.setState({
                        translation: json
                    })
                }).then(() => {
                    window.translate();
                });
        }

        fetch("" + '/erp/OrderEntry/ShipToLocations', {
            headers: {
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json();
        }).then((result) => {
            if (result.error) {
                console.error(`fetch error: ${result.error}`);
                var error = result.error;
                CustomerPortalAction.displayGeneralMessage(undefined, 'oe-' + error);
                return false;
            }

            let shipToLocations = result.shipToLocations;
            let shipViaCodes = result.shipViaCodes;

            if (shipViaCodes && shipViaCodes.length != 0) {
                this.setState({
                    shipViaCodes: shipViaCodes
                });
                //this.setSelectedShipViaCode(shipViaCodes[0]);
            }

            if (shipToLocations && shipToLocations.length != 0) {
                this.setState({
                    shipToLocations: shipToLocations,
                });
                this.setSelectedShipToLocation(shipToLocations[0]);
            } else {
                // get billing address
                fetch('/erp/customer/customerinfo/', {
                    headers: {
                        'Authorization': authenticationService()
                    }
                }).then((response) => {
                    if (response.status !== 200)
                        throw new Error(response.status)
                    return response.json();
                }).then((info) => {
                    if (info) {
                        this.setState({
                            shipToName: info.shipToName,
                            address1: info.billingAddress,
                            address2: "",
                            country: info.country,
                            city: info.city,
                            stateOrProvince: info.state,
                            zipOrPostalCode: info.zipCode,
                            phoneNumber: info.phoneNumber,
                            email: info.email,
                            disabled: false
                        });
                    }
                }).catch((error) => {
                    console.error(`fetch error: ${error}`);
                });
            }

            this.setState({ isLoading: false });
        }).then(() => {
            window.translate();
        }).catch((error) => {
            console.error(`fetch error: ${error}`);
        });
    }
    render() {
        let erp = CustomerPortalStore.getERP();
        if (this.state.isLoading || !this.state.translation) {
            return (
                <Loading />
            )
        }
        let header = <div className="top div-white-background py-0  container-fluid">
            <div className="row">
                <div className="col col-12 col-md-6 oe-border-line py-3">
                    <label data-translation="orderEntry.shipToLocation">Ship-to Location</label>
                    <select disabled={!this.state.shipToLocations || this.state.shipToLocations.length == 0} className="form-control" name="shipToLocation" value={this.state.selectedShipToLocation} onChange={(e) => { this.handleShipToLocationChange(e) }}>
                        {this.state.shipToLocations && this.state.shipToLocations.length > 0 ?
                            this.state.shipToLocations.map((entry) => {
                                return (<option key={entry.id} value={entry.id} data-translation={(entry.id == BILLING_ADDRESS_SHIPTO) ? ("orderEntry.DefaultShipToLocation") : ("")}>{entry.id}</option>)
                            })
                            : (false)}
                        {erp != "SageIntacct" ? (<option value="">--NEW--</option>) : (false)}
                    </select>

                    <div className={"show collapse" + (this.state.open ? ' in' : '')}>
                        <label data-translation="orderEntry.shipToName">Ship To Name</label>
                        <input type="text" maxLength="60" className="form-control" name="shipToName" disabled={this.state.disabled} value={this.state.shipToName} onChange={(e) => { this.handleChange(e) }}></input>
                        <label data-translation="orderEntry.address1">Address 1</label>
                        <input type="text" maxLength="60" className="form-control" name="address1" disabled={this.state.disabled} value={this.state.address1} onChange={(e) => { this.handleChange(e) }}></input>
                        <label data-translation="orderEntry.address2">Address 2</label>
                        <input type="text" maxLength="60" className="form-control" name="address2" disabled={this.state.disabled} value={this.state.address2} onChange={(e) => { this.handleChange(e) }}></input>

                        <div className="row">
                            <div className="col">
                                <label data-translation="orderEntry.country">Country</label>
                                <input type="text" maxLength="30" className="form-control" name="country" disabled={this.state.disabled} value={this.state.country} onChange={(e) => { this.handleChange(e) }}></input>
                            </div>
                            <div className="col">
                                <label data-translation="orderEntry.city">City</label>
                                <input type="text" maxLength="30" className="form-control" name="city" disabled={this.state.disabled} value={this.state.city} onChange={(e) => { this.handleChange(e) }}></input>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <label data-translation="orderEntry.stateProvince">State/Province</label>
                                <input type="text" maxLength="30" className="form-control" name="stateOrProvince" disabled={this.state.disabled} value={this.state.stateOrProvince} onChange={(e) => { this.handleChange(e) }}></input>
                            </div>
                            <div className="col">
                                <label data-translation="orderEntry.zipPostalCode">Zip/Postal Code</label>
                                <input type="text" maxLength="20" className="form-control" name="zipOrPostalCode" disabled={this.state.disabled} value={this.state.zipOrPostalCode} onChange={(e) => { this.handleChange(e) }}></input>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <label data-translation="orderEntry.phone">Phone</label>
                                <input type="text" maxLength="30" className="form-control" name="phoneNumber" disabled={this.state.disabled} value={this.state.phoneNumber} onChange={(e) => { this.handleChange(e) }}></input>
                            </div>
                            <div className="col">
                                <label data-translation="orderEntry.email">Email</label>
                                <input type="email" maxLength="50" className="form-control" name="email" disabled={this.state.disabled} value={this.state.email} onChange={(e) => { this.handleChange(e) }}></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col col-12 col-md-6 mb-4 mb-md-0 py-3 d-flex flex-column">
                    <label data-translation="orderEntry.poNumber">PO Number</label>
                    <div>
                        <div className="input-group">
                            <input type="text" maxLength="22" className="form-control text-uppercase mr-md-4" name="poNumber" onBlur={(e) => { this.handleChange(e) }}></input>
                            <span className="input-group-addon btn btn-info teal d-none d-md-block"
                                onClick={this.toggle.bind(this)}>
                                {this.state.open ? <i className="fa fa-chevron-up"></i> : <i className="fa fa-chevron-down"></i>}
                            </span>
                        </div>
                    </div>

                    <div className={"d-flex flex-column flex-grow-1 show collapse" + (this.state.open ? ' in' : '')}>
                        <div className='w-50 form-group mb-0'>
                            <label data-translation="orderEntry.requestDeliveryDate">Request Delivery Date</label>
                        </div>
                        <div className='w-50 form-group position-relative mb-0'>
                            <i className="fa fa-calendar click-through" aria-hidden="true"></i>
                            <input type="text" autoComplete='off' className="form-control datepicker form-control-i pl-3"
                                   value={this.state.requestDeliveryDate || ""} name="requestDeliveryDate" onKeyDown={this.handleDeliverDateChange.bind(this)} onChange={(e)=>{}}
                                   placeholder = {dateFormat}
                             />
                        </div>
                        {this.state.shipVia ?
                            <div>
                                <label data-translation="orderEntry.shipViaCode">Ship Via Code</label>
                                <select disabled={!this.state.shipViaCodes || this.state.shipViaCodes.length == 0}
                                    className="form-control" name="shipViaCode" value={this.state.selectedShipViaCode}
                                    onChange={(e) => { this.handleShipViaCodeChange(e) }}>
                                    <option value="">--NONE--</option>
                                    {this.state.shipViaCodes && this.state.shipViaCodes.length > 0 ?
                                        this.state.shipViaCodes.map((entry) => {
                                            return (<option key={entry.code} value={entry.code}>{entry.code} - {entry.name}</option>)
                                        })
                                        : (false)}
                                </select>
                            </div>
                            : (false)}
                        <div className='form-group d-flex flex-column flex-grow-1'>
                            <label data-translation="orderEntry.commentsShippingInstructions">Comments/Shipping Instructions</label>
                            <textarea className="form-control flex-grow-1" maxLength="250" rows="4" defaultValue={this.state.comments} name="comments" onBlur={(e) => { this.handleChange(e) }}></textarea>
                        </div>
                    </div>
                </div>
                <div className='col-12 d-md-none'>
                    <span className="btn btn-custom w-100 mx-0 mb-3"
                        onClick={this.toggle.bind(this)}>
                        {this.state.open ? <i className="fa fa-chevron-up"></i> : <i className="fa fa-chevron-down"></i>}
                    </span>
                </div>
            </div>
        </div>;

        let detail = <div className="div-white-background mt-4 p-0">
            <div className='oe-table border-table table list-table table-hover'>
                <div className='table-row table-header no-hover'>
                    <div className="table-cell col-item">
                        <label data-translation="orderEntry.item">Item</label>
                    </div>
                    <div className="table-cell col-desc">
                        <label data-translation="orderEntry.description">Description</label>
                    </div>
                    <div className="table-cell col-quantity">
                        <label className="" data-translation="orderEntry.quantity">Quantity</label>
                    </div>
                    <div className="table-cell col-uom">
                        <label className="" data-translation="orderEntry.uom">UOM</label>
                    </div>
                    <div className="table-cell col-price">
                        <label className="" data-translation="orderEntry.price">Price</label>
                    </div>
                    <div className="table-cell col-ext-price">
                        <label className="" data-translation="orderEntry.extendedPrice">Ext. Price</label>
                    </div>
                    <div className="table-cell col-dlt text-center">
                        <label className="" data-translation="orderEntry.remove">Remove</label>
                    </div>
                </div>
                {this.state.items.map((item, i) => {
                    return (
                        <div className='table-row' key={'item-' + item.itemNo + '-' + i}>
                            <div className='table-cell col-item'>
                                <span className='mobile title' data-translation="orderEntry.item">Item</span>
                                <span>
                                    {(this.state.hasShowItemDetails && item.type === 'Item') ? <button className="btn btn-link no-padding text-left" disabled={this.state.isFetching} onClick={(e) => { this.fetchPricingWithDetails(item, i) }}>{item.itemNo}</button> : item.itemNo}
                                </span>
                            </div>
                            <div className='table-cell col-desc'>
                                <span className='mobile title' data-translation="orderEntry.description">Description</span>
                                <span>
                                    {(this.state.hasShowItemDetails && item.type === 'Item') ? <button className="btn btn-link no-padding text-left" disabled={this.state.isFetching} onClick={(e) => { this.fetchPricingWithDetails(item, i) }}>{item.description}</button> : item.description}
                                </span>
                            </div>

                            <div className='table-cell col-quantity'>
                                <span className='mobile title' data-translation="orderEntry.quantity">Quantity</span>
                                {(item.type == 'Item') ? <input className="order-entry-quantity" name="quantity" ref={"quantity"} type="number" disabled={this.state.isFetching} onFocus={(e) => { e.target.select(); }} value={item.quantity} onChange={(e) => { this.handlePricingChange(e, i, true) }} onBlur={(e) => { this.handlePricingChange(e, i) }}></input> : (false)}
                            </div>

                            <div className='table-cell col-uom'>
                                <span className='mobile title' data-translation="orderEntry.price">UOM</span>
                                {item.UOMs && item.UOMs.length > 1 ?
                                    (<select className="select-custom bold " value={item.uom} name="uom" disabled={this.state.isFetching} onChange={(e) => { this.handlePricingChange(e, i) }}>
                                        {item.UOMs.map((uom) => {
                                            return (<option key={uom} value={uom}>{uom}</option>)
                                        })}
                                    </select>) : <span className="">{item.uom}</span>}
                            </div>
                            <div className='table-cell col-price'>
                                <span className='mobile title' data-translation="orderEntry.uom">Price</span>
                                {this.state.allowPriceOverride ?
                                    (<span>
                                        <input
                                          className="order-entry-price"
                                          value={(typeof item.price == "number") ? (window.formatNum(item.price,2,6)) : (item.price)}
                                          type="number"
                                          name="unitPrice"
                                          ref={"unitPrice"}
                                          disabled={this.state.isFetching}
                                          onFocus={(e) => { e.target.select(); }}
                                          onChange={(e) => { this.overWriteUnitPrice(e, i) }}>
                                        </input>
                                    </span>)
                                    :
                                    (<span className="">${window.formatNum(item.price || 0)}</span>)
                                }
                            </div>
                            <div className='table-cell col-ext-price'>
                                <span className='mobile title' data-translation="orderEntry.extendedPrice">Ext. Price</span>
                                <span className="">${window.formatNum(item.extendedPrice || 0)}</span>
                            </div>
                            <div className='table-cell col-dlt text-center'>
                                <span onClick={this.remove.bind(this, item)}><i className="fa fa-trash text-danger btn "></i></span>
                            </div>
                        </div>
                    )
                })}

            </div>

            <div className="mt-3 px-3 div-search-box">
                <label data-translation="orderEntry.addItem" id="test">ADD ITEM</label>
                <div className="dropdown-content container-fluid px-0">
                    <div className='row'>
                        <div className='col-12 col-md-5 px-md-0 pl-0'>
                            <ItemSearchInput placeholder={this.state.translation.orderEntry.searchItem} disabled={!this.state.value} id="itemSearchBox" onChange={value => this.onInputChange(value)}></ItemSearchInput>
                        </div>

                        {this.state.hasShowItemDetails ?
                            <label className="checkbox-inline ml-5 text-uppercase"><input
                                name="showItemDetails"
                                className="green-background"
                                type="checkbox"
                                checked={this.state.showItemDetails}
                                onChange={this.handleInputChange} /> <span data-translation="orderEntry.showItemDetails">Show Item Details</span></label> :
                            (false)}
                    </div>
                </div>
            </div>
            <br></br>
        </div>;
        let subTotal = 0;
        this.state.items.map(function (item, index) {
            subTotal += parseFloat(item.extendedPrice);
        })
        let footer = <div className="row row-eq-height mt-4">
            <div className="col-12 col-md-8 mb-3 mb-md-0">
                <div className="div-background div-gray-background d-flex align-items-center p-4 h-100">
                    {this.state.noteToCustomer ?
                        <div>
                            <h5 data-translation="orderEntry.note">Note</h5>
                            <p className='m-0 pre-line'>
                                {this.state.noteToCustomer}
                            </p>
                        </div> : (false)}
                </div>
            </div>
            <div className="col-12 col-md-4">
                <div className="div-background div-dark-background d-flex align-items-center p-3 h-100">
                    <h4 className=""><span data-translation="orderEntry.subtotal">SUBTOTAL</span>
                        <span className="ml-4">${window.window.formatNum(subTotal)}</span>
                    </h4>
                </div>
            </div>
            <div className='d-flex justify-content-end custom-btn-group w-100 mx-2 my-4'>
                <button className="d-print-none btn btn-custom btn-outline-custom " type="submit" data-translation="orderEntry.clear" onClick={this.clear.bind(this)}>Clear</button>
                {(this.state.orderTypes && this.state.orderTypes.length > 0) ?
                    <div>
                        {this.state.orderTypes.map((opt, index) =>
                            <button className="d-print-none btn btn-custom " key={opt} type="submit" data-translation={opt === "Quote" ? "orderEntry.placeQuote" : "orderEntry.placeOrder"} disabled={this.state.onSubmit} onClick={this.submit.bind(this, opt)}>Place {opt}</button>
                        )}

                    </div>
                    : (false)
                }
            </div>
        </div >;

        let prompt = (this.state.translation.orderEntry) ? <Prompt
            when={this.state.confirmToClose && (this.state.items && this.state.items.length > 0)}
            message={this.state.translation.orderEntry.areYouSureToLeave}
        /> : (false);

        let content = <div className='div-oe-form'>
            {prompt}
            <div className='page-title'><span data-translation="orderEntry.title">Order Entry</span> <i data-toggle="tooltip" className="tooltip-inner" data-placement="right" title="You can use the tab keys to go through the fields. When searching items, try to use the enter key to add items quicker" className="fa fa-question-circle"></i></div>
            {header} {detail} {footer}
        </div>;
        return (content);
    }
}

export default withRouter(OrderEntry);
